import React from "react";
import type { JSX } from "react";
import { connect } from "react-redux";
import { Form } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

import { isSet } from "shared/utils/utils";
import { IAction } from "actions";
import { IState } from "states/states";

import "./FileUploadBox.scss";

interface IFileUploadBoxExtProps {
  children: JSX.Element;
  className?: string;
  selectedFileChanged: (filepath: File | undefined) => void;
}

interface IFileUploadBoxState {
  currentAlert?: string | JSX.Element;
}

interface IFileUploadBoxProps {}

const mapStateToProps = (state: IState) => {
  const props: IFileUploadBoxProps = {};
  return props;
};

interface IFileUploadBoxDispatch {}

const mapDispatchToProps = (dispatch: (action: IAction<any>) => void) => {
  const dispatchProps: IFileUploadBoxDispatch = {};
  return dispatchProps;
};

class FileUploadBoxComponent extends React.Component<
  IFileUploadBoxProps & IFileUploadBoxExtProps & IFileUploadBoxDispatch,
  IFileUploadBoxState
> {
  state = {
    currentAlert: undefined,
  };

  public render() {
    return (
      <>
        {isSet(this.state.currentAlert) && (
          <div className="alert alert-danger m-4">{this.state.currentAlert}</div>
        )}
        <div
          className={`fileUploadDiv ${this.props.className}`}
          onDragEnter={(e) => {
            e.preventDefault();
            e.stopPropagation();
            e.dataTransfer.effectAllowed = "all";
            e.dataTransfer.dropEffect = "copy";
          }}
          onDragOver={(e) => {
            e.preventDefault();
            e.stopPropagation();
            e.dataTransfer.effectAllowed = "all";
            e.dataTransfer.dropEffect = "copy";
          }}
          onDrop={(e) => {
            e.preventDefault();
            e.stopPropagation();
            e.dataTransfer.effectAllowed = "all";
            e.dataTransfer.dropEffect = "copy";

            if (e.dataTransfer.files?.length === 1) {
              this.handleSelectedFile(e.dataTransfer.files[0]);
            } else if (e.dataTransfer.files?.length > 1) {
              this.setState({
                currentAlert: <FormattedMessage id="Only 1 file at once allowed on import!" />,
              });
            }
          }}
        >
          <div className="file">
            <p className="center">
              <b>
                <FormattedMessage id="Import data from file" />
              </b>
            </p>
            <div className="center">
              <span className="me-1 ">
                <FormattedMessage id="Drop file here or" />
              </span>
              <span
                className="link"
                onClick={(e) => {
                  document.getElementById("file_upload")?.click();
                }}
              >
                <FormattedMessage id="click to upload" />
              </span>
              <input
                id="file_upload"
                type="file"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                onChange={(e) =>
                  this.handleSelectedFile(e.target.files?.[0], () => {
                    e.target.value = "";
                  })
                }
              />
            </div>
            <div className="fileHint">{this.props.children}</div>
          </div>
        </div>
      </>
    );
  }

  private handleSelectedFile = (file: File | undefined, clearInput?: () => void) => {
    // check if a file was selected
    if (!file) {
      return;
    }
    // check if the file is an xlsx file
    if (file.name.toLowerCase().endsWith(".xlsx")) {
      this.setState({ currentAlert: undefined });
      // this.props.selectedFileChanged(file);
      return;
    }
    // in case of an error -> clear the input and show an alert
    clearInput?.();
    // this.props.selectedFileChanged(undefined);
    this.setState({
      currentAlert: <FormattedMessage id="Only .xlsx files are supported for import!" />,
    });
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FileUploadBoxComponent);
